const Error = ({ ...props }) => {
    return (
        <svg
            width="26"
            height="26"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 26 26"
            {...props}
        >
            <circle cx="13" cy="13" r="13" fill="#D52941" />
            <path
                fill="#D52941"
                d="M13 0C5.828 0 0 5.828 0 13s5.828 13 13 13 13-5.828 13-13S20.172 0 13 0zm0 1.3c6.47 0 11.7 5.23 11.7 11.7 0 6.47-5.23 11.7-11.7 11.7-6.47 0-11.7-5.23-11.7-11.7C1.3 6.53 6.53 1.3 13 1.3z"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M17.84 7.241L7.277 17.804l.92.92L18.758 8.16l-.92-.92z"
                clipRule="evenodd"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M8.14 7.147l-.919.92L17.86 18.705l.919-.919L8.14 7.147z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export default Error
